import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HeroImage from "../../assets/images/OtherServicesPage.jpg";
import ContentSection from "../components/ContentSection";
import AccountantImage from "../../assets/images/John-Savva-Accountants.jpg";
import ServicesGrid from "../components/ServicesGrid";
import GridImage1 from "../../assets/images/Other Services Page (2).jpg";
import GridImage2 from "../../assets/images/Other Services Page (3).jpg";
import GridImage3 from "../../assets/images/Other Services Page (4).jpg";
import GridImage4 from "../../assets/images/Other Services Page (5).jpg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";

const faqItems = [
  {
    question: "Why do I need financial protection?",
    answer:
      "Financial protection can safeguard you and your family from unexpected life events, such as illness, disability, job loss, or death. It can act as a safety net to cover your financial commitments and help to prevent you from depleting your savings during difficult times",
  },
  {
    question: "What are the main types of financial protection?",
    answer:
      "There are several types of financial protection which include life insurance, income protection, critical illness cover, and mortgage payment protection.",
  },
  {
    question: "How do I know how much cover I need?",
    answer:
      " To determine the appropriate amount of coverage, you should calculate your monthly outgoings, review existing cover you have and assess other possible options.",
  },
  {
    question: "Can I rely on state benefits if I get sick?",
    answer:
      "For most people state benefits, such as Statutory Sick Pay, are insufficient to cover essential household expenses. While state support provides a basic level of assistance, a financial protection plan is usually necessary to maintain your family's quality of life and prevent reliance on your savings. ",
  },
  {
    question:
      "What is the difference between income protection and critical illness cover?",
    answer:
      "These two types of insurance are often confused, but they serve different purposes. Critical illness cover pays a single lump sum upon diagnosis of a specific serious illness covered by the policy. Income protection pays a regular monthly income if you cannot work due to illness or injury.",
  },
  {
    question: "How often should I review my financial protection?",
    answer:
      " Your need for financial protection will change throughout your life, so you should review your coverage regularly. Major life events, such as buying a house, getting married, having children, or changing jobs, are particularly good times to reassess your needs. A review ensures your coverage remains aligned with your current financial obligations and life stage",
  },
];
const items = [
  {
    title: "Financial Planning",
    description: [
      "As part of the Rosemount Financial Solutions (IFA) Ltd network we have access to a range of financial planners and advisers who specialise in fields that we don’t cover. Let us know what you need help with, and we will put you in touch with the right specialist.",
      "We do not provide advice in these areas and are not responsible for the services provided by third-party advisers.",
    ],
    image: GridImage1,
    imageAlt: "Keys exchange",
  },
  {
    title: "General Insurance",
    description: [
      "These are areas that we can advise on, however we believe all advice should be provided by a specialist to ensure our clients get the best possible solution to meet their objectives. Let us know what you need assistance with, and we will find the right adviser for you.",
    ],
    image: GridImage2,
    imageAlt: "Meeting",
  },
  {
    title: "Solicitors and Conveyancing",
    description: [
      "We have access to a number of providers and will find the one who best meets your needs and budget.",
    ],
    image: GridImage3,
    imageAlt: "Mortgage discussion",
  },
  {
    title: "Wills and Powers of Attorney",
    description: [
      "Discussing what happens after we have gone can be a difficult subject to address,  we can put you in touch with local advisers that can assist you in this area, please let us know if you require any details.",
      "Wills, Powers of Attorney, and Estate or Inheritance planning advice are not regulated by the FCA",
    ],
    image: GridImage4,
    imageAlt: "Buy to let",
  },
];

export function OtherServicesPage() {
  const navigate = useNavigate();
  return (
    <>
      <Hero
        title={"Other Services"}
        subtitle={""}
        backgroundImage={HeroImage}
      />
      <div className="text-button-container">
        <p>
          Although we specialise in mortgage and protection advice, often during
          our conversations with clients the need for other professional
          services arises. Although we may not specialise in these areas
          ourselves, it will often tie in with the work we are carrying out and
          our clients’ overall financial plan, therefore it is important to us
          that our clients have access to the right professionals and services.
        </p>
        <p>
          We have cultivated relationships with other businesses and
          professionals that match our approach and ethos to advice and customer
          service, so we can recommend them with confidence safe in the
          knowledge they will look after our clients to the highest standard.
        </p>
        <p>
          If you need help with any of the following, please feel free to
          contact us and we will put you in touch with the right people.
        </p>{" "}
        <Button
          text="Start your journey with us"
          onClick={() => navigate("/contact")}
        />
      </div>
      <ServicesGrid items={items} />
      <div className="text-button-container">
        <h2 className="ContactUs">Accountants & Tax Advisers</h2>
        <ContentSection
          title="John Savva"
          paragraphs={[
            "",
            "John Savva has been an accountant since 1996 working mainly in taxation in a large firm in the city of London and this is where I met John and when I first started working with him in the tax department.",
            "He then moved to a niche West End practice, specialising in owner managed business, after which he established this current practice in March 2005. John Savva Accountants & Tax Advisors now bring their expert knowledge of tax planning to owner managed business and high net worth individuals. We have remained in contact both professionally and as friends and John is now my trusted company accountant.",
          ]}
          image={AccountantImage}
          imageAlt="Mortgage consultant"
          imagePosition="left"
          buttonText="Find out More"
          helperText="*Tax advice is not regulated by FCA."
          //   url="http://johnsavva.co.uk/"
          onClick={() => window.open("http://johnsavva.co.uk/", "_blank")}
          showDivider={true}
          backgroundColor="light"
        />
      </div>
      <div className="footer-disclaimer  ">
        <div
          className="footer-Content Column
        "
        >
          <h2>Surveys</h2>
          <p>
            including Basic Valuations, Home Buyers Report, Full Structural
            Surveys, Specialist Property Reports and EPC Certificates
          </p>
          <p>
            We work with a range of providers and we will find you the
            specialist you need.
          </p>
        </div>
      </div>
      <div className="text-button-container">
        <h2 className="ContactUs">Check my file</h2>
        <p>
          When applying for a mortgage, understanding what lenders can see on
          your credit report before you apply is a huge benefit. Therefore, we
          recommend checkmyfile as they provide all the information from the
          three largest credit reference agencies in one report. 
        </p>
        <p>
          Try it FREE for 7 days, then £14.99 a month – cancel online anytime.
        </p>
        <Button
          text="Claim your free trial now"
          onClick={() =>
            window.open(
              "https://www.checkmyfile.com/?partner=8676&transaction=b81582afaa1a4e75a27b601008d1a6d3&utm_source=everflow&utm_medium=referral&utm_campaign=8676",
              "_blank",
            )
          }
        />
      </div>
      {/* <FaqAccordion items={faqItems} /> */}
    </>
  );
}
